import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getDownloadRequestSearchOption = get(
  'downloadRequestSearchOption'
);

export const getUserSearchOptions = createSelector(
  getDownloadRequestSearchOption,
  get('users')
);

export const getIsFetching = createSelector(
  getDownloadRequestSearchOption,
  get('fetching')
);
export const getIsFetched = createSelector(
  getDownloadRequestSearchOption,
  get('fetched')
);
export const getFetchingError = createSelector(
  getDownloadRequestSearchOption,
  get('fetchingError')
);
